var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasAnyPerms([
      'menu.stats_multy_event',
      'admin.stats.sales_report',
      'admin.stats.saas_payments_total',
      'admin.stats.saas_payments_list'
    ]))?_c('CSidebarNavTitle',[_vm._v(_vm._s(_vm.$gettext('Reports')))]):_vm._e(),(_vm.hasAnyPerms(['admin.stats.sales_report', 'admin.stats.saas_payments_total', 'admin.stats.saas_payments_list']))?_c('CSidebarNavItem',{attrs:{"name":_vm.$gettext('Sales report'),"to":{name: 'salesReport'},"icon":"cip-file-03"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }